export const isValidUrlWithProtocol = (url: string): boolean => {
  const pattern = /^https:\/\/[\w.-]+(?:\.[\w.-]+)+[^.][\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;%=]*$/
  return pattern.test(url)
}
